module.exports = __webpack_public_path__ + "static/img/minus.b1e09594.svg";